module.exports = __webpack_public_path__ + "img/01建材行业.832c4da8.jpg";